import React, { Component } from 'react';
import { Grid, Icon, Form, Button, Segment, Dropdown, Radio, Modal } from 'semantic-ui-react';
import { getRequestedHoldInfo } from '../../utils/rest';
import { holdDays } from '../../utils/defaults';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
import ReactTable from 'react-table';
import { patchConsumerHold, patchHold, resolveHold, resolveConsumerHold, exportXLSX } from '../../utils/rest';
import Loading from '../Loading';

class RequestedHold extends Component {
    constructor(props) {
        super(props);
        this.state = {
            holdItems: [],
            disabled: true,
            cltClientIds: [],
            openResolve: false,
            openHold: false,
            resolveType: 0,
            resolveReason: "",
            holdType: 0,
            holdComments: "",
            daysHold: "",
            setRow: {},
            loading: false
        };
    }

    componentDidMount() {
        this.props.addItem("helpFile", "am_view-requested-account-holds.md");
    }

    componentDidUpdate(prevProps) {
        if (this.props.items.currentCorporate !== prevProps.items.currentCorporate) {
            this.setState({
                holdItems: [],
                disabled: true,
                cltClientIds: [],
                openResolve: false,
                openHold: false,
                resolveType: 0,
                resolveReason: "",
                holdType: 0,
                holdComments: "",
                daysHold: "",
                setRow: {}
            })
        }
    }

    componentWillUnmount() {
        this.props.addItem("helpFile", null);
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.loadHoldDetails();
    }

    loadHoldDetails = () => {
        this.setState({
            loading: true
        }, () => {
            getRequestedHoldInfo(this.props.items.currentCorporate, this.state.cltClientIds).then((response) => {
                if (response !== null) {
                    this.setState({
                        holdItems: response
                    })
                }
            }).then(() => {
                this.setState({
                    loading: false
                })
            })
        });
    }

    handleChange = (e, evt) => {
        this.setState({
            [evt.name]: evt.value,
        })
    }

    handleRadioChange = (e, evt) => {

        this.setState({
            // eslint-disable-next-line
            [evt.name]: parseInt(evt.value)
        })
    }

    openResolve = (row) => {
        this.setState({
            openResolve: true,
            setRow: row
        })
    }

    openHold = (row) => {
        this.setState({
            openHold: true,
            setRow: row
        })
    }

    close = () => {
        this.setState({
            openHold: false,
            openResolve: false,
            resolveType: 0,
            resolveReason: "",
            holdType: 0,
            holdComments: "",
            daysHold: "",
            setRow: {},
            loading: false

        })
    }

    handleContinue = () => {
        this.setState({
            loading: true
        }, () => {
            let holdObject = {
                acoAccountId: this.state.setRow.acoAccountId,
                acoConsumerId: this.state.setRow.acoConsumerId,
                cltClientId: this.state.setRow.cltClientId,
                ctdId: this.state.setRow.ctdId,
                holdReason: this.state.setRow.holdReason,
                holdNumDays: this.state.daysHold,
                holdComments: this.state.holdComments
            }
            if (this.state.holdType === 0) {
                patchHold(this.props.items.currentCorporate, holdObject).then((response) => {
                    if (response !== null) {
                        this.close();
                    }
                }).then(() => {
                    this.setState({
                        loading: false
                    })
                })
            } else {
                patchConsumerHold(this.props.items.currentCorporate, holdObject).then((response) => {
                    if (response !== null) {
                        this.close();
                    }
                }).then(() => {
                    this.setState({
                        loading: false
                    })
                })
            }
        })
    }

    handleResolve = () => {
        this.setState({
            loading: true
        }, () => {
            let resolveObject = {
                acoAccountId: this.state.setRow.acoAccountId,
                acoConsumerId: this.state.setRow.acoConsumerId,
                resolveReason: this.state.resolveReason,
                cltClientId: this.state.setRow.cltClientId,
                ctdId: this.state.setRow.ctdId
            }
            if (this.state.resolveType === 0) {
                resolveHold(this.props.items.currentCorporate, resolveObject).then((response) => {
                    if (response !== null) {
                        this.setState((prevState) => ({
                            holdItems: prevState.holdItems.filter((hold) => {
                                return hold.ctdId !== this.state.setRow.ctdId;
                            })
                        }));
                        this.close();
                    }
                }).then(() => {
                    this.setState({
                        loading: false
                    })
                })
            } else {
                resolveConsumerHold(this.props.items.currentCorporate, resolveObject).then((response) => {
                    if (response !== null && response instanceof Array) {
                        this.setState((prevState) => ({
                            holdItems: prevState.holdItems.filter((hold) => {
                                return response.indexOf(hold.ctdId) === -1;
                            })
                        }));
                        this.close();
                    }
                }).then(() => {
                    this.setState({
                        loading: false
                    })
                })
            }
        });

    }

    render() {
        return (
            <div>
                {(this.state.loading) ? <Loading /> : ""}
                <BreadcrumbCustom {...this.props} parent="Account Management" child={[{ name: "View Requested Account Holds", url: null }]} />
                <Grid className="g-bkgd">
                    <Grid.Row>
                        <Grid.Column>
                            <Form className="small">
                                <Form.Group widths='equal'>
                                    <Form.Field width={6} className="required">
                                        <label>Select Client ID(s):</label>
                                        <Dropdown placeholder='Select Client ID(s)' className="fluid" multiple search selection options={this.props.items.clients}
                                            value={this.state.cltClientIds}
                                            name="cltClientIds"
                                            onChange={this.handleChange}></Dropdown>
                                    </Form.Field>
                                    <Form.Field width={6}>
                                        <Button className="small buttons basic push-down" onClick={this.handleSubmit} disabled={this.state.cltClientIds.length > 0 ? false : true}>
                                            <Icon name="external alternate"></Icon>View Requested Holds
                                        </Button>
                                    </Form.Field>
                                    <Form.Field width={4} />
                                </Form.Group>
                            </Form>
                            <Segment.Group>
                                <Segment raised color="grey" inverted>
                                    <h4 className="ui header">
                                        <i className="pause circle outline icon"></i>
                                        <div className="content">
                                            Requested Holds
                                        </div>
                                    </h4>
                                </Segment>
                                <Grid className="margin-bottom-5">
                                    <Grid.Column width={1} floated='right'>
                                        <Button onClick={() => {
                                            exportXLSX(
                                                {
                                                    "Client Acct#": "acoInvoiceId",
                                                    "Our Acct#": "acoAccountId",
                                                    "Consumer's Last Name": "conLastName",
                                                    "Consumer's First Name": "conFirstName",
                                                    "Principal": "acoPrincipal",
                                                    "Currency Code": "acoIsoCode",
                                                    "Total": "acoTotal",
                                                    "Reason": "holdReason",
                                                    "Status": "holdStatus"


                                                }, this.state.holdItems, "RequestedHolds.xlsx")
                                        }}
                                            className="ui left small icon button icon-export" data-inverted="" data-tooltip="Export Table Details to Spreadsheet" data-position="bottom right">
                                            <i className="file excel icon"></i>
                                        </Button>
                                    </Grid.Column>
                                </Grid>
                                <ReactTable noDataText={null} minRows={0} defaultPageSize={this.props.reactTable().pageSize} showPagination={this.state.holdItems.length > this.props.reactTable().pageSize ? true : false} filterable defaultFilterMethod={this.props._customFilter} className="celled -striped -highlight "
                                    data={this.state.holdItems}
                                    getNoDataProps={() => {
                                        return { style: { display: 'none' } };
                                    }}
                                    columns={[{
                                        Header: props => <span data-inverted="" data-tooltip="Your Account Number for this Billing" data-position="bottom left">Client Acct#</span>,
                                        accessor: 'acoInvoiceId',
                                        width: 100
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Our Agency’s Account Number" data-position="bottom left">Our Acct#</span>,
                                        accessor: 'acoAccountId',
                                        width: 100
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Consumer’s Last Name" data-position="bottom left">{this.props.t("lastname")}</span>,
                                        accessor: 'conLastName',
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Consumer’s First Name" data-position="bottom left">{this.props.t("firstname")}</span>,
                                        accessor: 'conFirstName',
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Principal Balance" data-position="bottom left">PB</span>,
                                        id: 'acoPrincipal',
                                        width: 100,
                                        style: {
                                            textAlign: "right"
                                        },
                                        accessor: row => (
                                            this.props._currencyFormat(row.acoPrincipal)
                                        )
                                    },{
                                        Header: props => <span data-inverted="" data-tooltip="Currency Code" data-position="bottom left">Currency Code</span>,
                                        style: {
                                            textAlign: "center"
                                        },
                                        accessor: 'acoIsoCode',
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Current Total Due" data-position="bottom left">Total</span>,
                                        id: 'acoTotal',
                                        width: 100,
                                        style: {
                                            textAlign: "right"
                                        },
                                        accessor: row => (
                                            this.props._currencyFormat(row.acoTotal)
                                        )
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Reason for Hold or Cancel" data-position="bottom left">Reason</span>,
                                        accessor: 'holdReason',
                                        width: 200,
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="The status of the account as of viewing." data-position="bottom left">Status</span>,
                                        accessor: 'holdStatus',
                                        width: 200
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Clickable Action Buttons" data-position="bottom right">{this.props.t("actions")}</span>,
                                        filterable: false,
                                        style: {
                                            textAlign: "center"
                                        },
                                        width: 100,
                                        Cell: row => (
                                            <div>
                                                <Button onClick={(e) => { this.openResolve(row.original) }} className="icon mini" data-tooltip="Resolve" data-position="top right" data-inverted="" ><Icon name="check" /></Button>
                                                <Button onClick={(e) => { this.openHold(row.original) }} className="icon mini" data-tooltip="Hold Again" data-position="top right" data-inverted="" ><Icon name="pause" /></Button>
                                            </div>
                                        )
                                    }]}
                                />
                            </Segment.Group>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Modal size="small" data={this.state.setRow} open={this.state.openResolve} onClose={this.close} closeIcon>
                    <Modal.Header>Resolve Hold</Modal.Header>
                    <Modal.Content>
                        <Segment.Group>
                            <Segment>
                                <Form>
                                    <Form.Field>
                                        <label>Comments:</label>
                                        <Form.TextArea name="resolveReason" value={this.state.resolveReason} onChange={this.handleChange}></Form.TextArea>
                                    </Form.Field>
                                    <Form.Field>
                                        <Radio
                                            label='Remove Hold only for this account.'
                                            name='resolveType'
                                            value="0"
                                            checked={this.state.resolveType === 0}
                                            onChange={this.handleRadioChange}
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <Radio
                                            label='Remove all Holds for this consumer.'
                                            name='resolveType'
                                            value="1"
                                            checked={this.state.resolveType === 1}
                                            onChange={this.handleRadioChange}
                                        />
                                    </Form.Field>
                                </Form>
                            </Segment>
                        </Segment.Group>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button.Group width={2} className="small buttons">
                            <Button onClick={this.close}>{this.props.t("close")}</Button>
                            <Button.Or />
                            <Button positive onClick={this.handleResolve}>Resolve</Button>
                        </Button.Group>
                    </Modal.Actions>
                </Modal>
                <Modal size="small" data={this.state.setRow} open={this.state.openHold} onClose={this.close} closeIcon>
                    <Modal.Header>Hold Again</Modal.Header>
                    <Modal.Content>
                        <Segment.Group>
                            <Segment>
                                <Form>
                                    <Form.Field>
                                        <label>Days to Hold:</label>
                                        <Dropdown placeholder='Select Day(s)' className="fluid" search selection options={holdDays}
                                            value={this.state.daysHold}
                                            name="daysHold"
                                            onChange={this.handleChange}></Dropdown>
                                    </Form.Field>
                                    <Form.Field>
                                        <label>Comments:</label>
                                        <Form.TextArea name="holdComments" value={this.state.holdComments} onChange={this.handleChange}></Form.TextArea>
                                    </Form.Field>
                                    <Form.Field>
                                        <Radio
                                            label='Add Hold only for this account.'
                                            name='holdType'
                                            value="0"
                                            checked={this.state.holdType === 0}
                                            onChange={this.handleRadioChange}
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <Radio
                                            label={'Add Holds to all this consumer\'s accounts.'}
                                            name='holdType'
                                            value="1"
                                            checked={this.state.holdType === 1}
                                            onChange={this.handleRadioChange}
                                        />
                                    </Form.Field>
                                </Form>
                            </Segment>
                        </Segment.Group>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button.Group width={2} className="small buttons">
                            <Button onClick={this.close}>{this.props.t("close")}</Button>
                            <Button.Or />
                            <Button positive onClick={this.handleContinue}>Continue Hold</Button>
                        </Button.Group>
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }
}
export default RequestedHold;


// WEBPACK FOOTER //
// ./src/app/ui/holds/RequestedHold.js